import React from "react";

const ColorDots = ({dots}) => {
    return (
        <div className="flex flex-col gap-1 justify-center items-center">
            {dots?.map((dot, index) => (
                <div
                    key={index}
                    title={dot.name}
                    className={`w-3 h-3 rounded-full`}
                    style={{ backgroundColor: dot.color }}
                />
            ))}
        </div>
    );
};

export default ColorDots;